import { EmailComponentType } from "./EmailComponents.type";
import { RFQInvitationEmailContent } from "./RFQInvitationEmailContent";
import { SubmissionDeadlineExtensionEmailContent } from "./SubmissionDeadlineExtensionEmailContent";
import { SupplierAwardedEmailContent } from "./SupplierAwardedEmailContent";
import { SupplierDeclinedEmailContent } from "./SupplierDeclinedEmailContent";

const EmailComponent = ({
	companyName,
	rfqTitle,
	projectTitle,
	additionalMessage,
	date,
	time,
	timeZone,
	emailType,
	currentCompanyName,
	attachment,
}: EmailComponentType) => {
	const commonProps = {
		companyName,
		rfqTitle,
		projectTitle,
		additionalMessage,
		date,
		time,
		timeZone,
		currentCompanyName,
		attachment,
	};

	switch (emailType) {
		case "rfqInvitation":
			return <RFQInvitationEmailContent {...commonProps} />;

		case "submissionDeadlineExtension":
			return <SubmissionDeadlineExtensionEmailContent {...commonProps} />;

		case "supplierAwarded":
			return <SupplierAwardedEmailContent {...commonProps} />;

		case "supplierDeclined":
			return <SupplierDeclinedEmailContent {...commonProps} />;

		default:
			console.warn(`Unknown email type: ${emailType}`);
			return null;
	}
};

export default EmailComponent;
